
import { useSettingModal } from '../../../../hooks/Context';
import {SettingContextI} from '../../../../types';
import { Button } from '../SettingButton';
import React from 'react';
import CreateCompanyClass from './CreateCompanyClass';

  
const CreateBtn: React.FC<any> = (props) => {
    const { setModalContent, setShowModal }: SettingContextI = useSettingModal();

    const onClick = () => {
        setModalContent(<CreateCompanyClass {...{Id:0,AnnualSubscription:0,SectorType:'',ClassificationType:'',ActiveStatus:true,IsSubmitted:true,ClassyTypeId:0}}/>);
        setShowModal(true);
    };
    
    return (
        <Button onClick={onClick} 
            style={{backgroundColor: "#11643C", cursor: "pointer",
            color: "#fff", border: "none", outline: "none", padding: "15px 20px", borderRadius: "5px"}}
        >
            Create Company Classiffication
        </Button>
    )
};

export default CreateBtn;

